import apiClient from './axios';

export const authApi = {
  /**
   * Функція для входу через Google OAuth
   */
  loginWithGoogle: async (data) => {
    try {

      // Перевіряємо, чи це ID Token (новий потік) чи authorization code (старий потік)
      if (data?.idToken) {
        // Новий потік: Google Identity Services з ID Token
        const response = await apiClient.post('/auth/google/token', { idToken: data.idToken });

        // Перевіряємо успішність авторизації
        if (response.data?.success && response.data?.token) {
          // Зберігаємо токен
          localStorage.setItem('token', response.data.token);

          // Зберігаємо інформацію про користувача
          const user = response.data.user;
          localStorage.setItem('user', JSON.stringify(user));


          return {
            success: true,
            user: user,
            token: response.data.token
          };
        } else {
          // Обробка випадку коли авторизація не успішна
          console.warn('⚠️ Authentication not successful:', response.data);

          return {
            success: false,
            error: response.data?.error || response.data?.message || 'Невідома помилка авторизації',
            requiresRegistration: response.data?.requiresRegistration,
            isFirstLogin: response.data?.isFirstLogin
          };
        }
      } else if (data?.code) {
        // Старий потік: OAuth Authorization Code Flow
        const response = await apiClient.post('/auth/google', {
          code: data.code,
          ...(data.redirectUri && { redirectUri: data.redirectUri }),
        });

        // Перевіряємо успішність авторизації
        if (response.data?.success && response.data?.token) {
          // Зберігаємо токен
          localStorage.setItem('token', response.data.token);

          // Зберігаємо інформацію про користувача
          const user = response.data.user;
          localStorage.setItem('user', JSON.stringify(user));


          return {
            success: true,
            user: user,
            token: response.data.token
          };
        } else {
          // Обробка випадку коли авторизація не успішна
          console.warn('⚠️ Authentication not successful:', response.data);

          return {
            success: false,
            error: response.data?.error || response.data?.message || 'Невідома помилка авторизації',
            requiresRegistration: response.data?.requiresRegistration,
            isFirstLogin: response.data?.isFirstLogin
          };
        }
      } else {
        // Немає ні idToken, ні code
        throw new Error('Не отримано ні ID токена, ні коду авторизації від Google');
      }
      
    } catch (error) {
      console.error('❌ Google login error:', error);
      
      // Детальна обробка різних типів помилок
      if (error.response) {
        // Помилка від сервера
        const errorMessage = error.response.data?.error || 
                           error.response.data?.message || 
                           `Помилка сервера: ${error.response.status}`;
        
        console.error('Server error details:', {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers
        });
        
        // Передаємо помилку далі з детальною інформацією
        throw new Error(errorMessage);
        
      } else if (error.request) {
        // Запит не дійшов до сервера
        console.error('Network error - no response from server');
        throw new Error('Сервер не відповідає. Перевірте чи запущений backend на порту 8080');
        
      } else {
        // Інша помилка
        throw error;
      }
    }
  },


  /**
   * Функція для перевірки валідності токена
   */
  validateToken: async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        return { valid: false, user: null };
      }
      
      
      const response = await apiClient.get('/auth/validate-token');
      
      const isValid = response.data?.valid || false;
      const user = response.data?.user || null;
      
      if (isValid && user) {
        // Оновлюємо інформацію про користувача
        localStorage.setItem('user', JSON.stringify(user));
      } else {
        // Токен недійсний - очищаємо сховище
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      
      return { 
        valid: isValid, 
        user: user 
      };
      
    } catch (error) {
      console.error('❌ Token validation error:', error);
      
      // Якщо помилка 401, токен точно недійсний
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      
      return { valid: false, user: null };
    }
  },

  /**
   * Функція для виходу з системи
   */
  logout: () => {
    
    // Очищаємо локальне сховище
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Очищаємо всі cookies (якщо використовуються)
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    
    // Перенаправляємо на сторінку входу
    window.location.href = '/login';
  },

  /**
   * Функція для отримання поточного користувача
   */
  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        return JSON.parse(userStr);
      }
      return null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  },

  /**
   * Функція для перевірки чи є користувач адміністратором
   */
  isAdmin: () => {
    const user = authApi.getCurrentUser();
    return user?.roles?.some(role => 
      role === 'ADMIN' || 
      role === 'ROLE_ADMIN' || 
      role?.name === 'ADMIN' || 
      role?.name === 'ROLE_ADMIN'
    ) || false;
  },

  /**
   * Тестова функція для перевірки з'єднання з API
   */
  testConnection: async () => {
    try {
      await apiClient.get('/auth/test');
      return true;
    } catch (error) {
      console.error('❌ Auth API is not accessible:', error);
      return false;
    }
  }
};

// Експортуємо за замовчуванням
export default authApi;